"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NamedSettingsButton = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const lodash_1 = require("lodash");
const Divider_1 = __importDefault(require("@material-ui/core/Divider"));
const Menu_1 = __importDefault(require("@material-ui/core/Menu"));
const MenuItem_1 = __importDefault(require("@material-ui/core/MenuItem"));
const Save_1 = __importDefault(require("@material-ui/icons/Save"));
const confirm_dialog_1 = require("../../confirm-dialog/confirm-dialog");
const table_toolbar_button_1 = require("../table-toolbar-button");
const create_dialog_1 = require("./create-dialog");
const named_settings_hook_1 = require("./named-settings-hook");
const named_settings_item_1 = require("./named-settings-item");
function NamedSettingsButton({ disabled, tag, }) {
    const anchorRef = (0, react_1.useRef)(null);
    const { openMenu, closeMenu, opened, savedItems, selectSaved, createSaved, deleteSaved, selectedItem, confirmDeleteDialog, createDialog, } = (0, named_settings_hook_1.useNamedSettingsMenu)(tag);
    const intl = (0, react_intl_1.useIntl)();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(table_toolbar_button_1.TableToolbarButton, { ref: anchorRef, disabled: disabled, label: react_1.default.createElement(Save_1.default, null), onClick: openMenu, tooltip: intl.formatMessage({
                id: 'EAS_TABLE_SAVED_MENU_BTN',
                defaultMessage: 'Uložené nastavení',
            }) }),
        react_1.default.createElement(Menu_1.default, { getContentAnchorEl: null, anchorEl: anchorRef.current, keepMounted: true, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
            }, MenuListProps: {
                disablePadding: true,
            }, open: opened, onClose: closeMenu },
            savedItems.map((saved, i) => (react_1.default.createElement(named_settings_item_1.NamedSettingsItem, { key: i, label: saved.name, selected: saved.id === selectedItem, closeMenu: closeMenu, onClick: () => selectSaved(saved) }))),
            react_1.default.createElement(Divider_1.default, null),
            react_1.default.createElement(MenuItem_1.default, { disabled: selectedItem === null, onClick: () => {
                    var _a;
                    (_a = confirmDeleteDialog.current) === null || _a === void 0 ? void 0 : _a.open();
                    closeMenu();
                } },
                react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TABLE_SAVED_MENU_DELETE", defaultMessage: "Smazat nastaven\u00ED" }))),
            react_1.default.createElement(MenuItem_1.default, { onClick: () => {
                    var _a;
                    (_a = createDialog.current) === null || _a === void 0 ? void 0 : _a.open();
                    closeMenu();
                } },
                react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TABLE_SAVED_MENU_CREATE", defaultMessage: "Ulo\u017Eit nastaven\u00ED" })))),
        react_1.default.createElement(confirm_dialog_1.ConfirmDialog, { ref: confirmDeleteDialog, onConfirm: () => deleteSaved(selectedItem), onCancel: lodash_1.noop, title: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TABLE_SAVED_REMOVE_DIALOG_TITLE", defaultMessage: "Varov\u00E1n\u00ED" }), text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_TABLE_SAVED_REMOVE_DIALOG_TEXT", defaultMessage: "Opravdu chcete smazat ulo\u017Een\u00E9 nastaven\u00ED ?" }) }),
        react_1.default.createElement(create_dialog_1.CreateDialog, { onConfirm: createSaved, ref: createDialog })));
}
exports.NamedSettingsButton = NamedSettingsButton;
//# sourceMappingURL=named-settings-button.js.map